import { NgModule } from '@angular/core';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { LibSharedComponentModule } from '@solvace/component';
import { SvcButtonModule } from '@solvace/component/svc-btn';
import { SvcControlsModule } from '@solvace/component/svc-controls';
import { SvcDialogsModule } from '@solvace/component/svc-dialogs';
import { TranslocoModule } from '@ngneat/transloco';
import { SvcLocationFieldComponent } from './svc-location-field.component';
import { ModalSelectAreaOrLocationComponent } from './modal-select-location/modal-select-area-or-location.component';
import { SvcLocationsService } from './service/svc-location.service';
import { SvcBtnIconModule } from '@solvace/component/svc-btn-icon';

@NgModule({
  declarations: [
    SvcLocationFieldComponent,
    ModalSelectAreaOrLocationComponent,
  ],
  imports: [
    LibSharedCommonModule,
    LibSharedComponentModule,
    TranslocoModule,
    SvcControlsModule,
    SvcButtonModule,
    SvcDialogsModule,
    SvcBtnIconModule,
  ],
  exports: [
    SvcLocationFieldComponent,
  ],
  providers: [
    SvcLocationsService,
  ],
})
export class SvcLocationFieldModule { }
